"use client";
import { Box, Heading, Text } from "@chakra-ui/react";
import { SectionTemplate } from "components/individuals/blocks";

export interface EnterpriseAboutSectionProps {
  title: string;
  titleColor: string;
  subtitle: string;
  additionalText: string;
  textColor: string;
  bg: string;
}

export const EnterpriseAboutSection = ({
  title,
  titleColor,
  subtitle,
  additionalText,
  textColor,
  bg,
}: EnterpriseAboutSectionProps) => {
  return (
    <SectionTemplate bg={bg}>
      <Heading
        as={"h2"}
        color={titleColor}
        fontSize={{
          base: 26,
          md: 34,
          lg: 38,
          xl: 45,
        }}
        fontWeight={"bold"}
        lineHeight={1.2}
        mb={{
          base: 6,
          lg: 8,
        }}
      >
        {title}
      </Heading>
      <Box
        color={textColor}
        fontSize={{
          base: 14,
          md: 16,
          lg: 17,
          xl: 18,
        }}
      >
        <Text
          mb={{
            base: 4,
            lg: 6,
          }}
        >
          {subtitle}
        </Text>
        <Text>{additionalText}</Text>
      </Box>
    </SectionTemplate>
  );
};
